import axios from "axios";

var PasswordBlacklist = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function (params) {
        return axios.post(
            Apollo.resolveApiUrl("~/passwordblacklist"),
            {
                params: params
            });
    },
    validate: function (password) {
        return axios.post(
            Apollo.resolveApiUrl("~/passwordblacklist"),
            {
                params: { password: password }
            });
    },
};

export default PasswordBlacklist;



// WEBPACK FOOTER //
// ./src/models/PasswordBlacklist.js